import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Es una dieta para adelgazar?',
  answer: "No es una 'dieta' restrictiva clásica. Es un protocolo de recomposición metabólica. El efecto secundario de equilibrar tus hormonas y apagar la inflamación es que perderás volumen y grasa, especialmente en la zona abdominal, pero sin pasar hambre."
}, {
  question: '¿Sirve si ya tengo la menopausia?',
  answer: 'Sí. Aunque está diseñado específicamente para la transición (premenopausia), los principios de nutrición circadiana y antiinflamatoria son igual de efectivos si ya has pasado la menopausia para mantener la salud ósea y metabólica.'
}, {
  question: '¿Necesito comprar suplementos caros?',
  answer: 'No. El protocolo se basa en alimentación real. Incluyo una guía de suplementación opcional para acelerar resultados, pero el 90% del éxito viene de la comida y los hábitos que te enseño.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí. Una vez compras SOS Premenopausia, el acceso es tuyo de por vida, incluyendo cualquier actualización futura que haga al programa.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después del pago recibirás un email con tus claves de acceso a nuestra plataforma privada donde podrás descargar todo el material y ver los vídeos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-cream" data-id="element-27">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark text-center mb-12" data-id="element-29">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-brand-warm-gray/10 overflow-hidden" data-id="element-31">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-32">
                <span className="font-serif font-bold text-brand-dark text-lg" data-id="element-33">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-terracotta" data-id="element-34" /> : <ChevronDown className="w-5 h-5 text-brand-warm-gray" data-id="element-35" />}
              </button>

              <AnimatePresence data-id="element-36">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-37">
                    <div className="px-6 pb-6 pt-0 text-brand-warm-gray font-sans leading-relaxed border-t border-gray-100 mt-2" data-id="element-38">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}